import React from 'react'
import { IconButton, useTheme } from '@mui/material'
import { Trash } from 'iconsax-react'

import { CustomFieldTableRowProps } from '../Row'
import CustomFieldInput from '@SonarCX/components/molecules/CustomFieldInput'

import useStyles from './styles'

export type CardProps = CustomFieldTableRowProps

const Card: React.FC<CardProps> = ({
  table,
  cells,
  meta,
  fields,
  canEdit,
  handleValueChange,
  onBlur,
  deleteRow
}) => {
  const theme = useTheme()

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <IconButton onClick={() => deleteRow(table.id, cells[0]?.row)}>
        <Trash
          size={theme.size.base}
          variant='Bulk'
          className={classes.deleteIcon}
        />
      </IconButton>

      <div className={classes.grid}>
        {cells.map((cellData, cellIndex) => {
          const field = fields.find(field => field.id === cellData.row_key)

          return (
            <div
              key={`${table.id}-${field.id}-${cellIndex}`}
              className={classes.data}
            >
              <div className={classes.dataTitle}>{field?.title}</div>

              <div style={{ marginTop: 0 }}>
                <CustomFieldInput
                  field={field}
                  value={
                    meta.find(
                      data =>
                        data.key === table.id &&
                        data.row_key === cellData.row_key &&
                        data.row === cellData.row
                    )?.value ?? ''
                  }
                  disabled={!canEdit}
                  canEdit={canEdit}
                  handleChange={handleValueChange}
                  handleBlur={onBlur}
                  row={cellData.row}
                  rowKey={cellData.row_key}
                  parent={table}
                  meta={meta}
                  task
                  inputOnly
                  inTable
                  // TODO: Add field filtering to tables
                  // shouldFilter
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Card
